<template>
  <div class="preseason-picks">
    <v-container fluid class="my-5">
      <v-tabs
        v-model="tab"
        background-color="primary"
        class="elevation-2"
        dark
        center-active
        show-arrows
        centered
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab v-for="i in tabs" :key="i" :href="`#tab-${i}`">{{ i }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(i, index) in tabs" :key="i" :value="'tab-' + i">
          <v-card flat v-if="index == 0">
            <Heisman />
          </v-card>
          <v-card flat v-if="index > 0 && index < 6">
            <Conference :name="i" />
          </v-card>
          <v-card flat v-if="index == 6">
            <CFP />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import Heisman from "@/components/preseason/Heisman";
import Conference from "@/components/preseason/Conference";
import CFP from "@/components/preseason/CFP";
export default {
  components: { Heisman, Conference, CFP },
  name: "PreseasonPicks",
  data() {
    return {
      tab: null,
      tabs: [
        "Heisman",
        "SEC",
        "ACC",
        "Big Ten",
        "Big 12",
        "Pac-12",
        "College Football Playoff"
      ]
    };
  }
};
</script>